import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageCode } from '@alltrails/core/hooks/useLanguageCode';
import useFeatures from '@alltrails/features/hooks/useFeatures';

export default function useAdaChatbot(): {
  isAdaReady: boolean;
  config: {
    handle: string | null;
    language: string;
  };
} {
  const features = useFeatures();
  const languageCode = useLanguageCode();
  const user = useUser();

  const isAdaReady = !!(features?.includes('ada_chatbot') && user);

  return {
    isAdaReady,
    config: {
      handle: process.env.NEXT_PUBLIC_ADA_HANDLE_GENERATIVE!,
      language: languageCode
    }
  };
}
